import { NgModel } from '@angular/forms';
import { DenuvoDatePipe } from './denuvo-date.pipe';
import { NgModule } from '@angular/core';
import { UUIDHashPipe } from './uuid-hash.pipe';
import { IntToHexPipe } from './int-to-hex.pipe';
import { ShortHashPipe } from './short-hash.pipe';
import { B64ToStringPipe } from './b64-to-string.pipe';
import { ShortDatePipe } from './short-date.pipe';
import {TimestampPipe} from './timestamp.pipe';

@NgModule({
    declarations: [
        DenuvoDatePipe,
        UUIDHashPipe,
        IntToHexPipe,
        ShortHashPipe,
        B64ToStringPipe,
        ShortDatePipe,
        TimestampPipe
    ],
    exports: [
        DenuvoDatePipe,
        UUIDHashPipe,
        IntToHexPipe,
        ShortHashPipe,
        B64ToStringPipe,
        ShortDatePipe,
        TimestampPipe
    ]
})
export class SharedModule {

}
